/* global gtag */
import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { FormGroup, Input } from "reactstrap";
import {
  ModalWrapper,
  ButtonGroup,
  InputAuth,
  ButtonNext,
  ButtonSend,
  InputWrapper,
  StyledH3,
  BackChoice,
  ButtonWpp,
  Suport,
  StyledH2,
  StyledInfo,
  WelcomeText,
  WelcomeTitle,
  ButtonOK,
  WelcomeAlert,
} from "./styles";
import api from "../../services/client/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faEnvelope,
  faInfoCircle,
  faPaperPlane,
  faPhone,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import {
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";

const InfoVerifyView = () => {
  const location = useLocation();
  const history = useHistory();
  const [preferredContact, setPreferredContact] = useState(null);
  const [emailChoosed, setEmailChoosed] = useState(false); // Estado para controlar se o e-mail foi escolhido
  const [phoneChoosed, setPhoneChoosed] = useState(false);
  const [, setSendingCode] = useState(false);
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [, setError] = useState("");
  const [messageSended, setMessageSended] = useState(false);
  const [showBackChoice, setShowBackChoice] = useState(true);
  const [showInput, setShowInput] = useState(false);

  const {
    username,
    mail,
    tel,
    id,
    token,
    firstName,
    role,
    codTitulo,
    codeDoctor,
    requirePermission,
    crm,
    name,
  } = location.state || {};
  const isMounted = useRef(true);
  const [modalOpen, setModalOpen] = useState(true);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  useEffect(() => {
    if (!username || !token || !role || !id) {
      history.replace("/login");
    }
  }, [username, token, role, id, history]);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Efeito para verificar se os valores de tel e mail não são nulos

  const handleChange = (event) => {
    setPreferredContact(event.target.value);
  };

  const maskEmail = (email) => {
    if (!email || email === "none" || !email.includes("@")) {
      return email; // retorna como está se for "none", null, undefined ou inválido
    }

    const [localPart, domain] = email.split("@");
    if (!domain || !localPart) return email;

    const maskedLocalPart =
      localPart.slice(0, 2) +
      "*".repeat(Math.max(0, localPart.length - 3)) +
      localPart.slice(-1);
    const [domainName, domainExt] = domain.split(".");
    if (!domainName || !domainExt) return email;

    const maskedDomain =
      domainName[0] +
      "*".repeat(Math.max(0, domainName.length - 1)) +
      "." +
      domainExt;
    return `${maskedLocalPart}@${maskedDomain}`;
  };

  const maskPhone = (phone) => {
    if (!phone || phone === "none" || phone.length < 3) {
      return phone; // retorna como está se for "none", null, undefined ou curto demais
    }

    // Remover o código do país (55, 54, etc) caso exista, deixando só o número do telefone
    const cleanPhone = phone.replace(/^\d{2}/, ""); // Remove os dois primeiros dígitos (código do país)

    // Adaptação da máscara para um número com código de país
    return `(**) *****-*${cleanPhone.slice(-3)}`;
  };

  useEffect(() => {
    if (mail !== null && tel !== null) {
      setPreferredContact("email"); // Definir o e-mail como padrão (pode ser alterado pelo usuário)
    } else {
      // Verificar se o email é nulo
      if (mail === null) {
        setPhoneChoosed(true); // Se o email for nulo, define que o telefone foi escolhido
        setShowBackChoice(false); // Se for nulo, desativa a escolha
      }
      // Verificar se o telefone é nulo
      if (tel === null) {
        setEmailChoosed(true); // Se o telefone for nulo, define que o email foi escolhido
        setShowBackChoice(false); // Se for nulo, desativa a escolha
      }
    }
  }, [mail, tel]);

  // Função para controlar a escolha do e-mail
  const handleContinue = () => {
    if (preferredContact === "email") {
      setEmailChoosed(true); // Marca o e-mail como escolhido
    } else if (preferredContact === "phone") {
      setPhoneChoosed(true); // Marca o e-mail como escolhido
    }
  };

  const sendMailCode = async () => {
    setSendingCode(true);

    try {
      // Enviar código de recuperação por e-mail

      const response = await api().user().sendMailVerification(mail, username);

      if (response.status === 200) {
        // ✅ GA4: Mail sended
        gtag("event", "mail_sended", {
          event_category: "send_mail_verify",
          value: 200,
        });

        setMessageSended(true);
        setShowInput(true);

        // Inicia o timer de 60 segundos
        setTimeout(() => {
          if (isMounted.current) {
            setMessageSended(false);
          } // Altera o estado para false após 60 segundos
        }, 300000); // 60000 milissegundos = 60 segundos
      }
    } catch (error) {
      const errorMessage = error.response
        ? error.response.status
        : "Erro de rede";
      setError(
        `Erro ao enviar código de recuperação: ${errorMessage}. Atualize a página e tente novamente.`,
      );
    } finally {
      setSendingCode(false); // Marca como não enviando o código
    }
  };
  const sendSmsCode = async () => {
    setSendingCode(true);

    try {
      let phoneNumber = tel;

      const response = await api()
        .user()
        .sendPhoneVerification(phoneNumber, username);

      if (response.status === 200) {
        // ✅ GA4: SMS sended
        gtag("event", "sms_sended", {
          event_category: "send_sms_verify",
          value: 200,
        });
        setMessageSended(true);
        setShowInput(true);
        // Inicia o timer de 60 segundos
        setTimeout(() => {
          if (isMounted.current) {
            setMessageSended(false);
          } // Altera o estado para false após 60 segundos
        }, 300000); // 60000 milissegundos = 60 segundos
      } else {
        // Exemplo de exibição de erro na interface
        alert("Falha no envio do SMS, tente novamente mais tarde.");
      }
    } catch (error) {
      const errorMessage = error.response
        ? error.response.status
        : "Falha no envio do SMS, tente novamente mais tarde.";
      setError(
        `Erro ao enviar código de recuperação via SMS: ${errorMessage}. Atualize a página e tente novamente.`,
      );
    } finally {
      setSendingCode(false); // Marca como não enviando o código
    }
  };

  const handleCodeChange = async (e, index) => {
    const value = e.target.value;

    // Permite apenas números de 0 a 9
    if (!/^\d?$/.test(value)) return;

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    const concatenatedCode = newCode.join("");

    // Verifica se o código tem exatamente 6 dígitos numéricos
    if (/^\d{6}$/.test(concatenatedCode)) {
      try {
        let verificationType;

        if (emailChoosed) {
          verificationType = 1;
        } else if (phoneChoosed) {
          verificationType = 2;
        }

        const response = await api()
          .user()
          .twoFactorVerify(concatenatedCode, id, verificationType, username);

        if (response.status === 200) {
          const verifiedDoctor = 1;
          history.replace({
            pathname: "/terms",
            state: {
              username,
              firstName,
              token,
              verifiedDoctor,
              requirePermission,
              codTitulo,
              codeDoctor,
              role,
              crm,
              name,
            },
          });
        } else {
          setError("Código inválido ou erro na resposta.");
        }
      } catch (error) {
        setError("Erro ao validar, Código inválido.");
      }
    } else {
      setError("O código deve ter exatamente 6 caracteres numéricos.");
    }

    // Move para o próximo campo automaticamente
    if (value && index < 5) {
      setTimeout(() => {
        document.getElementById(`input-${index + 1}`).focus();
      }, 100);
    }
  };

  const handleBackspace = (e, index) => {
    // Se a tecla pressionada for o Backspace
    if (e.key === "Backspace") {
      const newCode = [...code];

      if (code[index] === "") {
        // Se o campo atual estiver vazio, move o foco para o campo anterior
        if (index > 0) {
          // Apaga o valor do campo anterior
          newCode[index - 1] = "";
          setCode(newCode); // Atualiza o código
          setTimeout(() => {
            document.getElementById(`input-${index - 1}`).focus(); // Mover o foco para o campo anterior
          }, 100); // Delay para garantir que o foco seja movido após a atualização do estado
        }
      }
    }
  };

  // Função que move o foco para o próximo campo
  const handleFocus = (e, index) => {
    if (e.target.value.length === 1 && index < 5) {
      // Mover o foco para o próximo campo (caso não seja o último)
      document.getElementById(`input-${index + 1}`).focus();
    }
  };
  const noContact = (!mail || mail === "none") && (!tel || tel === "none");
  return (
    <>
      <Modal isOpen={modalOpen} toggle={toggleModal} centered size="lg">
        <ModalBody>
          <ModalWrapper>
            <WelcomeTitle>Bem-vindo(a)!</WelcomeTitle>

            <WelcomeText>
              Este é o seu primeiro acesso a exames compartilhados,
              disponibilizados em razão da sua participação na assistência ao
              paciente.
            </WelcomeText>

            <WelcomeText>
              Para garantir a segurança das informações e confirmar sua
              identidade, será realizada uma verificação em duas etapas. Após
              essa confirmação, você deverá ler e concordar com o Termo de
              Responsabilidade, Confidencialidade e Autorização antes de
              prosseguir.
            </WelcomeText>

            <WelcomeAlert>
              Este procedimento é realizado apenas no primeiro acesso e faz
              parte das medidas de proteção aos dados dos pacientes,
              estabelecidos por lei.
            </WelcomeAlert>

            <ButtonOK
              color="primary"
              onClick={toggleModal}
              style={{ marginTop: 30 }}
            >
              Entendi
            </ButtonOK>
          </ModalWrapper>
        </ModalBody>
      </Modal>
      <ModalWrapper>
        {noContact ? (
          <>
            <StyledH3>
              Não encontramos um e-mail ou telefone válido vinculado a sua
              credencial&nbsp;de&nbsp;acesso.
            </StyledH3>

            <StyledInfo>
              Por falta de informações do médico/usuário em nossa base de dados,
              não é possível realizar a confirmação de identidade. Entre em
              contato com nossa equipe de suporte para atualizar seus dados
              cadastrais e prosseguir com o acesso aos exames.
            </StyledInfo>
            <ButtonWpp href="https://wa.me/5547991153595">
              Contato
              <FontAwesomeIcon
                icon={faWhatsapp}
                style={{ marginLeft: "5px" }}
              />{" "}
            </ButtonWpp>
          </>
        ) : (
          <>
            {!emailChoosed && !phoneChoosed && (
              <>
                <StyledH3>
                  Você prefere receber&nbsp;a&nbsp;confirmação por&nbsp;E-mail
                  ou&nbsp;SMS?
                </StyledH3>

                {mail && tel && (
                  <FormGroup tag="fieldset" style={{ textAlign: "center" }}>
                    {mail !== "none" && (
                      <FormGroup check style={{ marginBottom: "15px" }}>
                        <Label check style={{ fontSize: "18px" }}>
                          <Input
                            type="radio"
                            name="preferredContact"
                            value="email"
                            checked={preferredContact === "email"}
                            onChange={handleChange}
                            disabled={phoneChoosed}
                          />
                          <FontAwesomeIcon
                            icon={faEnvelope}
                            style={{ margin: "0 8px" }}
                          />
                          E-mail: <b>{maskEmail(mail)}</b>
                        </Label>
                      </FormGroup>
                    )}
                    {tel !== "none" && (
                      <FormGroup check style={{ marginBottom: "15px" }}>
                        <Label check style={{ fontSize: "18px" }}>
                          <Input
                            type="radio"
                            name="preferredContact"
                            value="phone"
                            checked={preferredContact === "phone"}
                            onChange={handleChange}
                            disabled={emailChoosed}
                          />
                          <FontAwesomeIcon
                            icon={faPhone}
                            style={{ margin: "0 8px" }}
                          />
                          Telefone: <b>{maskPhone(tel)}</b>
                        </Label>
                      </FormGroup>
                    )}
                    <ButtonGroup>
                      <ButtonNext color="primary" onClick={handleContinue}>
                        Continuar
                      </ButtonNext>
                    </ButtonGroup>
                  </FormGroup>
                )}
              </>
            )}

            {phoneChoosed && (
              <>
                {messageSended ? (
                  <>
                    <StyledH2>
                      Código enviado
                      <FontAwesomeIcon
                        icon={faCheck}
                        style={{ color: "#4FC3F7", marginLeft: "6px" }}
                      />
                    </StyledH2>

                    <StyledH3>
                      Verifique seu SMS e digite o código no campo abaixo.
                    </StyledH3>

                    <StyledInfo>
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        style={{ marginRight: "6px", color: "#4FC3F7" }}
                      />
                      Lembre-se de verificar também sua <b>caixa de spam.</b>
                    </StyledInfo>
                  </>
                ) : (
                  <>
                    <StyledH3>
                      Clique no botão para enviar o código ao seu SMS.
                    </StyledH3>
                    <Label>
                      <FontAwesomeIcon
                        icon={faPhone}
                        style={{ marginRight: "5px" }}
                      />
                      Telefone: <b>{maskPhone(tel)}</b>
                    </Label>

                    <ButtonGroup>
                      <ButtonSend color="primary" onClick={sendSmsCode}>
                        <FontAwesomeIcon
                          icon={faPaperPlane}
                          style={{ marginRight: "5px" }}
                        />{" "}
                        Enviar Código
                      </ButtonSend>
                    </ButtonGroup>
                  </>
                )}
                {showInput && (
                  <InputWrapper>
                    {code.map((digit, index) => (
                      <InputAuth
                        key={index}
                        id={`input-${index}`}
                        maxLength="1"
                        type="text"
                        placeholder="-"
                        value={digit}
                        onChange={(e) => handleCodeChange(e, index)} // Altera o valor
                        onKeyUp={(e) => handleBackspace(e, index)} // Aciona o backspace
                        onFocus={(e) => handleFocus(e, index)} // Move o foco para o próximo campo
                        // Verifica se o campo está desabilitado
                      />
                    ))}
                  </InputWrapper>
                )}

                {showBackChoice && (
                  <ButtonGroup>
                    <BackChoice
                      color="secondary"
                      onClick={() => {
                        setPhoneChoosed(false);
                        setEmailChoosed(false);
                        setMessageSended(false);
                        setShowInput(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                      Tentar de outra forma
                    </BackChoice>
                  </ButtonGroup>
                )}
              </>
            )}

            {emailChoosed && (
              <>
                {messageSended ? (
                  <>
                    <StyledH2>
                      Código enviado
                      <FontAwesomeIcon
                        icon={faCheck}
                        style={{ color: "#4FC3F7", marginLeft: "6px" }}
                      />
                    </StyledH2>

                    <StyledH3>
                      Verifique seu e-mail e digite o código no campo abaixo.
                    </StyledH3>

                    <StyledInfo>
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        style={{ marginRight: "6px", color: "#4FC3F7" }}
                      />
                      Lembre-se de verificar também sua <b>caixa de spam.</b>
                    </StyledInfo>
                  </>
                ) : (
                  <>
                    <StyledH3>
                      Clique no botão para enviar o código ao seu e-mail.
                    </StyledH3>

                    <Label>
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        style={{ marginRight: "5px" }}
                      />
                      E-mail: <b>{maskEmail(mail)}</b>
                    </Label>
                    <ButtonGroup>
                      <ButtonSend color="primary" onClick={sendMailCode}>
                        <FontAwesomeIcon
                          icon={faPaperPlane}
                          style={{ marginRight: "5px" }}
                        />{" "}
                        Enviar Código
                      </ButtonSend>
                    </ButtonGroup>
                  </>
                )}

                {showInput && (
                  <InputWrapper>
                    {code.map((digit, index) => (
                      <InputAuth
                        key={index}
                        id={`input-${index}`}
                        maxLength="1"
                        type="text"
                        inputMode="numeric" // Garante que apareça o teclado numérico
                        pattern="[0-9]*" // Ajuda com dispositivos Android
                        placeholder="-"
                        value={digit}
                        onChange={(e) => handleCodeChange(e, index)} // Altera o valor
                        onKeyUp={(e) => handleBackspace(e, index)} // Aciona o backspace
                        onFocus={(e) => handleFocus(e, index)} // Move o foco para o próximo campo
                        // Verifica se o campo está desabilitado
                      />
                    ))}
                  </InputWrapper>
                )}

                {/* Botão para voltar à tela de escolha */}
                {showBackChoice && (
                  <ButtonGroup>
                    <BackChoice
                      color="secondary"
                      onClick={() => {
                        setPhoneChoosed(false);
                        setEmailChoosed(false);
                        setMessageSended(false);
                        setShowInput(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                      Tentar de outra forma
                    </BackChoice>
                  </ButtonGroup>
                )}
              </>
            )}
          </>
        )}
      </ModalWrapper>
      <Suport href="https://wa.me/5547991153595" target="_blank">
        <u>Suporte</u>
        <FontAwesomeIcon icon={faWhatsapp} color="#25d366" />
      </Suport>
    </>
  );
};

export default InfoVerifyView;
